var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { mBody4 } from '@teamsparta/design-system';
import styled from '@emotion/styled';
import { VerticalGap } from '../Gap/Gap';
var AlertText = function (_a) {
    var isShow = _a.isShow, children = _a.children, color = _a.color, spanColor = _a.spanColor;
    return (_jsx(_Fragment, { children: isShow && (_jsxs(AlertTextWrapper, __assign({ color: color, spanColor: spanColor }, { children: [_jsx(VerticalGap, { size: 8 }), children] }))) }));
};
export default AlertText;
var AlertTextWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  text-align: left;\n  ", ";\n  color: ", ";\n\n  span {\n    color: ", ";\n  }\n"], ["\n  width: 100%;\n  text-align: left;\n  ", ";\n  color: ", ";\n\n  span {\n    color: ", ";\n  }\n"])), mBody4, function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var spanColor = _a.spanColor;
    return spanColor;
});
var templateObject_1;
//# sourceMappingURL=AlertText.js.map